module.exports = __webpack_public_path__ + "img/allinone_home@3x.5617e0da.png";